import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaEye, FaEdit, FaTrash, FaEyeSlash } from "react-icons/fa";
import {
  getStaffList,
  deleteStaff,
  updateStaffStatus
} from "../../redux/services/Staff Services/Staff.Services";
import { successToast, errorToast } from "../../Utils/toast";
import { openModal } from "../../redux/features/modalSlice";
import Pagination from "../../common/Pagination";
import { useDispatch } from "react-redux";
// import Search from "../../common/Search";
function StaffLeadAssignList() {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [showPasswords, setShowPasswords] = useState({});
  const [search, setSearch] = useState("");
  const [staff, setStaff] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const fetchStaff = async (pageNo = 1, isInitialLoad = false) => {
    try {
      if (isInitialLoad) {
        setInitialLoading(true);
      } else {
        setTableLoading(true);
      }
      const payload = {
        page: pageNo,
        per_page: limit,
        search:search
      };
      const res = await getStaffList(payload);
      setStaff(res?.data || []);
      setPage(res?.current_page || 1);
      setTotalPages(res?.last_page || 1);
      setTotalRecords(res?.total || 0);
    } catch (error) {
      console.log(error);
      errorToast("Failed to load staff");
    } finally {
      setInitialLoading(false);
      setTableLoading(false);
    }
  };
useEffect(() => {
  fetchStaff(1, true);
}, []);

// Search change hone par
// useEffect(() => {
//   if (initialLoading) return;
//   fetchStaff(1, false);
// }, [search]);
  const handlePageChange = (newPage) => {
    if (
      newPage >= 1 &&
      newPage <= totalPages &&
      !tableLoading
    ) {
      setPage(newPage);
      fetchStaff(newPage, false);
    }
  };
  const togglePassword = (id) => {
    setShowPasswords((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  const openStatusModal = (item) => {
    dispatch(
      openModal({
        type: "update-status",
        title: "Change Staff Status",
        data: {
          id: item.id || item._id,
          status: item.status,
          entity: "staff",
          refetch: fetchStaff,
        },
      })
    );
  };
  const handleDelete = async (id) => {
    try {
      const res = await deleteStaff({ id });
      successToast(res?.message || "Deleted");

      fetchStaff();
    } catch (error) {
      errorToast(error?.message || "Delete failed");
    }
  };

  // STATUS TOGGLE
  const handleStatus = async (item) => {
    try {
      const res = await updateStaffStatus({
        id: item.id,
        status: item.status ? 0 : 1,
      });

      successToast(res?.message || "Status updated");
      fetchStaff();
    } catch (error) {
      errorToast("Status update failed");
    }
  };
  if (initialLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between  page-header-breadcrumb">
        <div className="title_member">
          <h4>New Lead List</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>New Leads</span>
          </nav>
        </div>
      </div>



     <div className="main_page">
{(totalRecords > 0 || search) && (
    <div className="d-flex justify-content-end align-items-center gap-2 mx-2 mb-2">
        {/* <Search
            search={search}
            placeholder="Search Staff..."
            onSearch={(value) => {
                setSearch(value);
                setPage(1);
            }}
        /> */}
        {totalPages > 1 && (
            <Pagination
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
        )}
    </div>
)}
      <div className="st-wrapper-card">
        <div className="st-table-responsive">
          <table className="table st-custom-table align-middle mb-0">

            <thead>
              <tr>
                <th>Name</th>
                <th style={{ whiteSpace: "nowrap" }}>Employee ID</th>
                <th>Email</th>
                <th>Password</th>
                <th>Mobile</th>
                <th>Role</th>
                <th>leads</th>
                <th>Date&Time</th>
                <th>Status</th>
                <th className="">Action</th>
              </tr>
            </thead>
            <tbody>
              {tableLoading ? (
                <tr>
                  <td colSpan="10" className="text-center py-5">
                    <div className="spinner-border text-primary"></div>
                  </td>
                </tr>
              ) : staff?.length > 0 ? (
                staff.map((item) => (
                  <tr key={item.id}>
                    <td>{item?.name}</td>
                    <td>{item?.staff_detail?.employee_id}</td>
                    <td>{item?.email}</td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <span>
                          {showPasswords[item.id]
                            ? item.simple_pass
                            : "••••••"}
                        </span>

                        <button
                          type="button"
                          className="btn btn-sm p-0 border-0 text-light"
                          onClick={() => togglePassword(item.id)}
                        >
                          {showPasswords[item.id] ? (
                            <FaEyeSlash />
                          ) : (
                            <FaEye />
                          )}
                        </button>
                      </div>
                    </td>
                    <td>{item.staff_detail?.mobile}</td>
                    <td>{item.role}</td>
                    <td>
                      <div className="d-flex gap-2">
                        <button
                          className="lead-btn btn-import"
                          onClick={() => navigate(`/assignd-task-list/${item.id}`)}
                        >
                          {/* <FaEye  /> */}
                          lead Assign
                        </button>
                      </div>
                    </td>
                    <td>
                      {item.updated_at
                        ? (() => {
                          const date = new Date(item.updated_at);

                          const formattedDate = date
                            .toLocaleDateString("en-GB")
                            .replace(/\//g, "-");

                          const formattedTime = date.toLocaleTimeString("en-GB", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          });

                          return `${formattedDate} ${formattedTime}`;
                        })()
                        : "-"}
                    </td>
                    {/* STATUS */}
                    <td style={{ width: "150px" }}>
                      <div className="city-status-switch">

                        <input
                          type="checkbox"
                          id={`status-${item._id || item.id}`}
                          className="city-status-input"
                          checked={
                            item.status === "active" ||
                            item.status === 1 ||
                            item.status === true
                          }
                          onChange={() => openStatusModal(item)}
                        />

                        <label
                          htmlFor={`status-${item._id || item.id}`}
                          className="city-status-label"
                        >
                          <span className="city-status-ball"></span>

                          <span className="city-status-text">
                            {(item.status === "active" || item.status === 1)
                              ? "Active"
                              : "Inactive"}
                          </span>

                        </label>

                      </div>
                    </td>
                    <td >
                      <div className="d-flex align-items-center justify-content-center gap-1">
                        <button
                          className="st-action-btn st-view-btn"
                          onClick={() =>
                            navigate(`/assign-view/${item.id}`)
                          }
                        >
                          <FaEye />
                        </button>

                        <button
                          className="st-action-btn st-edit-btn"
                          onClick={() =>
                            navigate(`/update-staff/${item.id}`)
                          }
                        >
                          <FaEdit />
                        </button>

                        {/* <button
                              className="btn btn-sm btn-primary"
                              onClick={() => navigate(`/assign-lead-show/${staffMember.id}`)}
                            >
                              <FaEye />
                            </button> */}


                        <button
                          className="st-action-btn st-delete-btn"
                          // onClick={() => handleDelete(item.id)}
                          onClick={() =>
                            dispatch(
                              openModal({
                                type: "delete-staff",
                                title: "Delete Staff",
                                data: {
                                  id: item.id,
                                  deleteFunction: deleteStaff,
                                  refreshData: fetchStaff,
                                },
                              })
                            )
                          }
                        >
                          <FaTrash />
                        </button>
                      </div>


                    </td>

                  </tr>
                ))

              ) : (

                <tr>
                  <td colSpan="10" className="text-center py-4">
                    No Staff Found
                  </td>
                </tr>

              )}


            </tbody>

          </table>
        </div>
      </div>

      {totalPages > 1 && (
        <div className="d-flex justify-content-end mt-3">
          <Pagination
            page={page}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      )}
     </div>
    </div>

  );
}

export default StaffLeadAssignList;